
export default {
  props: {
    labels: {
      required: true,
      type: Array,
      default: () => [],
    },
    values: {
      required: true,
      type: Array,
      default: () => [],
    },
    name: {
      required: true,
      type: String,
      default: () => null,
    },
    defaultValue: {
      type: String, // Change the type as needed
      default: null,
    },
    disabled: {
      type: Boolean, // Change the type as needed
      default: false,
    },
    isLoaded: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      selectedValues: this.defaultValue
        ? [this.defaultValue]
        : this.values.slice(), // Set default value if provided
    };
  },
  computed: {
    computedItems() {
      return this.labels.slice();
    },
  },
  watch: {
    defaultValue(newVal) {
      if (newVal !== null) {
        this.selectedValues = [newVal];
      }
    },
  },
  methods: {
    handleFilterChange() {
      this.$emit('productFilterUpdated', [this.selectedValues, this.name]);
    },
  },
};
